// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__1TCPE","content":"styles_content__5ZptU","selectAll":"styles_selectAll__1OI8P"};